import { Box } from '@mui/material';
import { grey, blue } from '@mui/material/colors';
import { FC, ReactNode } from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

interface IProps {
  title: string | ReactNode;
  value: string | number;
  operation?: string;
  linkTo?: string;
  showText?: boolean;
}
const CaseDataBarItem: FC<IProps> = ({ title, value, operation, linkTo, showText = false }) => {
  const isLinked = operation && linkTo && window?.cortiCodeAPI?.runOpenMedicusCommand;

  const handleClick = () => {
    if (!isLinked) return;
    window?.cortiCodeAPI?.runOpenMedicusCommand(operation, `int32:${linkTo}`);
  };
  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        borderRadius: '4px',
        padding: '8px',
        color: grey[500],
        '&:hover': {
          cursor: isLinked ? 'pointer' : 'default',
          color: isLinked && blue[800],
          backgroundColor: isLinked ? blue[50] : 'transparent',
        },
      }}
    >
      <Box
        sx={{
          fontStyle: 'normal',
          fontWeight: 400,
          fontSize: '14px',
          letterSpacing: '0.15px',
        }}
        className="dd-privacy-allow"
      >
        {title}
      </Box>
      <Box
        sx={{
          fontSize: '16px',
          color: isLinked ? blue[600] : 'black',
          maxWidth: '500px',
          wordBreak: 'break-all',
          textAlign: 'left',
          fontStyle: 'normal',
          fontWeight: 400,
          letterSpacing: '0.15px',
        }}
        className={showText && 'dd-privacy-allow'}
      >
        {value || '-'}
        {isLinked && (
          <OpenInNewIcon
            sx={{
              fontSize: '14px',
              ml: 0.5,
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default CaseDataBarItem;
